import $ from 'wee-dom';
import $events from 'wee-events';
import $fetch from 'wee-fetch';
import $location from 'wee-location';
import $screen from 'wee-screen';
import $store from 'wee-store';
import { RouteHandler } from 'wee-routes';
import { _body } from 'core/variables';
import itemTemplate from './popup/item-template';
import listTemplate from './popup/list-template';
import Tabbable from '../../scripts/tabbable';
import KeyHelper from '../../scripts/keyhelper';

export default new RouteHandler({
    init() {
        const $socialContainer = $(':socialContainer');
        const socialStorage = $store.create('socials', {
            browserStorage: 'session',
            prefix: 'usa_health',
        });

        if (! socialStorage.get('items')) {
            $fetch({
                url: `${$location.uri().origin}/ajax/socials`,
            }).then(({ data }) => {
                data.forEach((el) => {
                    el.html = itemTemplate(el);
                });
                socialStorage.set('items', data);
            }).catch(e => console.error(e));
        }

        $events.on({
            body: {
                click(e) {
                    const elements = [
                        ...$socialContainer.toArray(),
                        ...$socialContainer
                            .filter('.js-populated')
                            .find('*')
                            .toArray(),
                        ...$(':socialButton').toArray(),
                    ];

                    if (! elements.includes(e.target)) {
                        $socialContainer.hide();
                    }
                },
                keydown(e) {
                    if (KeyHelper.isEsc(e)) {
                        $socialContainer.hide();
                    }
                }
            },
            ':socialButton': {
                click(e, el) {
                    const $el = $(el);
                    const $popup = $el.siblings(':socialContainer');
                    const platform = $el.data('social');
                    const socials = [];

                    if (! $popup.hasClass('js-populated')) {
                        socialStorage.get('items').forEach((item) => {
                            if (platform === item.platform) {
                                socials.push(item.html);
                            }
                        });
                    }

                    $socialContainer.addClass('js-hide');

                    if ($popup.hasClass('js-hide')) {
                        $popup.append(listTemplate(socials))
                            .show()
                            .addClass('js-populated');

                        if ($screen.size() <= 2) {
                            $(_body).css('overflow', 'hidden');
                        }

                        this.tabbable = new Tabbable({
                            el: $popup,
                            callback: () => {
                                this.tabbable.$firstEl[0].focus();
                            }
                        });
                    } else {
                        $popup.hide();
                    }

                    e.preventDefault();
                },
            },
            ':closeSocial': {
                click(e, el) {
                    $(_body).css('overflow', 'auto');
                    $(el).closest(':socialContainer').hide();

                    e.preventDefault();
                },
            },
        });
    },
});
